import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import {
  getTab,
  updateTabIndex,
} from 'domains/Shipping/DeliveryMethods/deliveryMethodsSlice';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';

const formatId = (translate: string) =>
  `tab-${translate.toLowerCase().replace(' ', '-')}`;

function useTabToShow() {
  const t = useTranslationShipping('deliveryMethods.tabs');
  const dispatch = useAppDispatch();
  const tab = useSelector(getTab);
  const changeTabToShow = (id: string) => {
    let selectedTab = tab;
    switch (id) {
      case formatId(t('nationals')):
        selectedTab = 0;
        break;
      case formatId(t('international')):
        selectedTab = 1;
        break;
      case formatId(t('phisical')):
        selectedTab = 3;
        break;
      case formatId(t('pickup')):
        selectedTab = 2;
        break;
      default:
        selectedTab = 0;
        break;
    }
    dispatch(updateTabIndex(selectedTab));
  };
  return {
    tab,
    changeTabToShow,
  };
}

export default useTabToShow;
